import { GetRestockMetricsQuery } from "~/gql/queries/restock/restockMetrics.generated";

export const restockMetricsEndpoints = {
	GetRestockMetrics: {
		providesTags: ["RestockMetrics"] as AddTagTypes,
		transformResponse: (res: GetRestockMetricsQuery) => res
	}
};
